import React from 'react';

const PlayIconVideo = (args) => (
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...args}
  >
    <path
      d="M52.6259 27C52.6259 40.9224 41.167 52.2339 27.0004 52.2339C12.8339 52.2339 1.375 40.9224 1.375 27C1.375 13.0776 12.8339 1.76611 27.0004 1.76611C41.167 1.76611 52.6259 13.0776 52.6259 27Z"
      stroke="white"
      strokeOpacity="0.5"
      strokeWidth="2"
    />
    <path
      d="M21.9482 37.519L36.1804 25.8723L21.7142 14.6908L21.9482 37.519Z"
      fill="white"
      fillOpacity="0.5"
    />
  </svg>
);

export default PlayIconVideo;
